import { MenuOutlined } from '@ant-design/icons'
import { Button, Dropdown, MenuProps } from 'antd'
import { FC } from 'react'
import RewindQueueEntry from '../../../../../../../../types/api/rewind-queue-entry'
import useMoveToMachineMenuItem from '../../../../move-to-machine/use-move-to-machine-menu-item'

interface GroupOperationsDropdownProps {
    selected: RewindQueueEntry[]
    onMoved: () => void
}

const GroupOperationsDropdown: FC<GroupOperationsDropdownProps> = ({ selected, onMoved }) => {
    const moveToMachineMenuItem = useMoveToMachineMenuItem(
        selected,
        'Переместить в другую очередь',
        onMoved
    )
    const items: MenuProps['items'] = [moveToMachineMenuItem]

    return (
        <Dropdown menu={{ items }}>
            <Button size='small' icon={<MenuOutlined />} />
        </Dropdown>
    )
}

export default GroupOperationsDropdown
